import React from 'react';
import LogbookFullView from './LogbookFullView';
import { useVessel } from '../../../../contexts/VesselContext';

const LogbookTabCompact = ({
  logEntries = [],
  activeVoyage,
  voyages = [],
  onAddEntry,
  onClearToday,
  onRemoveDuplicates,
  onSelectVoyage,
  // FT-356: pass through to LogbookFullView so it can register a shell-level
  // back handler.
  onBack
}) => {
  const { getCurrentVessel } = useVessel();
  const currentVessel = getCurrentVessel();

  // Simply render the full-width logbook view
  return (
    <LogbookFullView
      logEntries={logEntries}
      activeVoyage={activeVoyage}
      voyages={voyages}
      onAddEntry={onAddEntry}
      onSelectVoyage={onSelectVoyage}
      currentVessel={currentVessel}
      onBack={onBack}
    />
  );
};

export default LogbookTabCompact;